import TimeRange from "@/types/time-range";
import { api } from "@/lib/api";
import { Dimension } from "@/lib/dimensions";
import { parseStandardDataDimensions } from "@/lib/dimensions/helpers";
import { BoundingBox } from "@/lib/map-layers/abstract/base-tiled-layer/tiled-deck-gl-layer";

export type WmsLayerData = {
  extent?: BoundingBox;
  dimensions: Dimension[];
};

export default class WmsLayerDataLoader {
  private dashboardId;
  private mapLayerId;

  constructor(dashboardId: string, mapLayerId: string) {
    this.dashboardId = dashboardId;
    this.mapLayerId = mapLayerId;
  }

  async loadLayerData(timeRange: TimeRange): Promise<WmsLayerData> {
    const response = await api.published.getPublishedMapLayerData(
      this.dashboardId,
      this.mapLayerId,
      timeRange.timeStart.toISOString(),
      timeRange.timeEnd.toISOString(),
    );

    return {
      dimensions: parseStandardDataDimensions(response.data.dimensions),
      extent: response.data.bounding_box && {
        north: response.data.bounding_box.north_bound_latitude,
        east: response.data.bounding_box.east_bound_longitude,
        south: response.data.bounding_box.south_bound_latitude,
        west: response.data.bounding_box.west_bound_longitude,
      },
    };
  }
}
